import { useEffect, useState } from 'react';
import './EnfantsPage.css';

const CATEGORIES = [
  { key: 'ses-enfants', label: 'Ses enfants', color: '#c47840' },
  { key: 'touches', label: "Ceux qui l'ont touche", color: '#8b1a2a' },
  { key: 'enfants', label: 'Les enfants du monde entier', color: '#b05070' }
];

const SES_ENFANTS_ORDER = ['Prince', 'Paris', 'Bigi'];

export default function EnfantsPage() {
  const [posts, setPosts] = useState([]);
  const [texts, setTexts] = useState({});
  const [activeCategory, setActiveCategory] = useState('ses-enfants');
  const [selected, setSelected] = useState(null);

  const fetchPosts = async (cat) => {
    const res = await fetch('/api/children-posts?category=' + cat);
    const data = await res.json();
    setPosts(data);
  };

  const fetchTexts = async () => {
    const res = await fetch('/api/children-posts/texts');
    const data = await res.json();
    const map = {};
    data.forEach(t => { map[t.category] = t; });
    setTexts(map);
  };

  useEffect(() => { fetchPosts(activeCategory); fetchTexts(); }, [activeCategory]);

  const cat = CATEGORIES.find(c => c.key === activeCategory);
  const t = texts[activeCategory];

  if (selected) {
    const sCat = CATEGORIES.find(c => c.key === selected.category);
    return (
      <div className="ep-article-page">
        <div className="ep-article-inner">
          <button className="ep-back" onClick={() => setSelected(null)}>← Retour</button>
          <div className="ep-article-cat" style={{ color: sCat?.color }}>{sCat?.label}</div>
          {selected.pinned && <span className="ep-pin-badge">Article epingle</span>}
          <h1 className="ep-article-title">{selected.title}</h1>
          <img src={selected.imageUrl} alt={selected.title} className="ep-article-img" />
          <div className="ep-article-body">
            {selected.content.split('\n').map((p, i) => p.trim() ? <p key={i}>{p}</p> : null)}
          </div>
        </div>
      </div>
    );
  }

  const sortedSesEnfants = activeCategory === 'ses-enfants'
    ? [...posts].sort((a, b) => {
        const ai = SES_ENFANTS_ORDER.findIndex(n => a.title.toLowerCase().includes(n.toLowerCase()));
        const bi = SES_ENFANTS_ORDER.findIndex(n => b.title.toLowerCase().includes(n.toLowerCase()));
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
      })
    : posts;

  return (
    <div className="ep-page">
      <div className="ep-eyebrow">Michael — Les enfants</div>
      <h1 className="ep-title">Michael & les enfants, <em>un amour universel</em></h1>
      <p className="ep-intro">Michael Jackson vouait un amour profond aux enfants du monde entier — les siens, ceux qu'il a rencontres, ceux qu'il a voulu toucher par sa musique et son engagement.</p>

      <div className="ep-tabs">
        {CATEGORIES.map(c => (
          <button key={c.key}
            className={'ep-tab' + (activeCategory === c.key ? ' active' : '')}
            style={activeCategory === c.key ? { background: c.color, borderColor: c.color } : {}}
            onClick={() => setActiveCategory(c.key)}>{c.label}</button>
        ))}
      </div>

      {activeCategory === 'ses-enfants' ? (
        <div>
          <div className="ep-portraits">
            {sortedSesEnfants.length === 0 ? (
              ['PRINCE', 'PARIS', 'BIGI'].map(name => (
                <div key={name} className="ep-portrait-wrap">
                  <div className="ep-frame"><div className="ep-frame-inner ep-placeholder"></div></div>
                  <div className="ep-nameplate"><div className="ep-nameplate-inner"><span>{name}</span></div></div>
                </div>
              ))
            ) : (
              sortedSesEnfants.map(post => {
                const nameMatch = SES_ENFANTS_ORDER.find(n => post.title.toLowerCase().includes(n.toLowerCase()));
                const displayName = nameMatch ? nameMatch.toUpperCase() : post.title.toUpperCase();
                return (
                  <div key={post._id} className="ep-portrait-wrap" onClick={() => setSelected(post)}>
                    <div className="ep-frame">
                      <div className="ep-frame-inner">
                        <img src={post.imageUrl} alt={post.title} />
                      </div>
                    </div>
                    <div className="ep-nameplate"><div className="ep-nameplate-inner"><span>{displayName}</span></div></div>
                  </div>
                );
              })
            )}
          </div>

          <div className="ep-encadre">
            <div className="ep-enc-mono">MJ</div>
            <div className="ep-enc-label" style={{ color: '#c8a84b' }}>Ses enfants</div>
            <div className="ep-enc-divider"></div>
            {t?.title && <div className="ep-enc-title">{t.title}</div>}
            {t?.text && <div className="ep-enc-text">{t.text}</div>}
            {!t?.title && !t?.text && <div className="ep-enc-text" style={{ color: '#bbb' }}>Texte a remplir depuis l'administration.</div>}
            <div className="ep-enc-ornament">✦ ✦ ✦</div>
          </div>
        </div>
      ) : (
        <div>
          {(t?.title || t?.text) && (
            <div className="ep-section-header" style={{ borderLeftColor: cat?.color }}>
              <div className="ep-section-label" style={{ color: cat?.color }}>{cat?.label}</div>
              {t.title && <div className="ep-section-title">{t.title}</div>}
              {t.text && <div className="ep-section-text">{t.text}</div>}
            </div>
          )}
          {posts.length === 0 && <p className="ep-empty">Aucun article pour l'instant.</p>}
          <div className="ep-masonry">
            {posts.map(post => {
              const pCat = CATEGORIES.find(c => c.key === post.category);
              const excerpt = post.content.length > 180 ? post.content.slice(0, 180) + '...' : post.content;
              return (
                <div key={post._id} className={'ep-card' + (post.pinned ? ' pinned' : '')} onClick={() => setSelected(post)}
                  style={post.pinned ? { borderColor: pCat?.color } : {}}>
                  {post.pinned && <div className="ep-pin">📌</div>}
                  <div className="ep-card-img"><img src={post.imageUrl} alt={post.title} loading="lazy" /></div>
                  <div className="ep-card-body">
                    <div className="ep-card-title">{post.title}</div>
                    <div className="ep-card-excerpt">{excerpt}</div>
                    <div className="ep-read" style={{ color: pCat?.color }}>Lire l'article →</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
